import type { IdeaCardPreviewData } from '@/lib/idea-card-types';
import { TikTokProfileMockup } from './TikTokProfileMockup';
import { InstagramProfileMockup } from './InstagramProfileMockup';
import { YouTubeChannelMockup } from './YouTubeChannelMockup';
import { TikTokVideoMockup } from './TikTokVideoMockup';
import { InstagramReelMockup } from './InstagramReelMockup';
import { InstagramPostMockup } from './InstagramPostMockup';
import { InstagramCarouselMockup } from './InstagramCarouselMockup';
import { InstagramStoryMockup } from './InstagramStoryMockup';
import { YouTubeVideoMockup } from './YouTubeVideoMockup';
import { YouTubeShortMockup } from './YouTubeShortMockup';
import { CalendarMockup } from './CalendarMockup';
import { ComparisonViewMockup } from './ComparisonViewMockup';
import { ChartMockup } from './ChartMockup';

interface FormatTypeRendererProps {
  preview: IdeaCardPreviewData;
}

export const FormatTypeRenderer = ({ preview }: FormatTypeRendererProps) => {
  const { type, props } = preview;

  switch (type) {
    // Profile mockups
    case 'tiktok_profile':
      return <TikTokProfileMockup {...props} previewLabel={preview.label} />;

    case 'instagram_profile':
      return <InstagramProfileMockup {...props} previewLabel={preview.label} />;

    case 'youtube_channel':
      return <YouTubeChannelMockup {...props} description={props.description || ''} previewLabel={preview.label} />;

    // Video mockups
    case 'tiktok_video':
      return <TikTokVideoMockup {...props} previewLabel={preview.label} />;

    case 'instagram_reel':
      return <InstagramReelMockup {...props} previewLabel={preview.label} />;

    case 'youtube_video':
      return <YouTubeVideoMockup {...props} title={props.title || 'Video Title'} previewLabel={preview.label} />;

    case 'youtube_short':
      return <YouTubeShortMockup {...props} previewLabel={preview.label} />;

    // Post mockups
    case 'instagram_post':
      return <InstagramPostMockup {...props} caption={props.caption || ''} previewLabel={preview.label} />;

    case 'instagram_carousel':
      return <InstagramCarouselMockup {...props} caption={props.caption || ''} previewLabel={preview.label} />;

    case 'instagram_story':
      return <InstagramStoryMockup {...props} previewLabel={preview.label} />;

    case 'calendar':
      return <CalendarMockup {...props} month={props.month || ''} events={props.events || '[]'} previewLabel={preview.label} />;

    case 'comparison_view':
      return <ComparisonViewMockup {...props} items={props.items || '[]'} previewLabel={preview.label} />;

    case 'chart':
      return <ChartMockup {...props} chartType={props.chartType || 'bar'} data={props.data || '[]'} previewLabel={preview.label} />;

    default:
      return null;
  }
};
